import { setActiveTab } from '../actions/companyUsers'

const PageActions = ({ superAdmin, companyUsersUrl, userInvitationsUrl, dispatch }) => (
  <span>
    {
      superAdmin && <span><a href={`${companyUsersUrl}/new`} className="btn btn-primary">Add Existing User</a>&nbsp;</span>
    }
    <Link to={userInvitationsUrl} className="btn btn-primary" onClick={e => {
      dispatch(setActiveTab('invited', true))
    }}>Invite Users</Link>
  </span>
)
const mapStateToProps = ({ superAdmin, userInvitationsUrl, companyUsersUrl }) => ({ superAdmin, userInvitationsUrl, companyUsersUrl })
export default connect(mapStateToProps)(PageActions)


// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/PageActions.js